export enum TeamEventType{
	Game='Game',
	Practice='Practice',
	Social='Social',
}